import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageLayout, Typography, TYPOGRAPHY_SIZE } from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { JobForm } from 'src/pages/jobs/components/job-form';
import { useUpsertJob } from 'src/hooks/jobs/upsert-job.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';

const CreateJob = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'jobs']);

  const currentCompanyId = useGetCurrentCompanyId();
  const upsertJob = useUpsertJob();

  const onFinish = (values: any) => {
    upsertJob({
      variables: { payload: { ...values, platformCompanyId: currentCompanyId } },
      onCompleted: () => navigate(ROUTES.jobs),
    });
  };

  return (
    <PageLayout pageTitle={t('jobs:labels.createJob')}>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('jobs:labels.createJob')}
      </Typography>
      <JobForm onCancel={() => navigate(ROUTES.jobs)} onFinish={onFinish} />
    </PageLayout>
  );
};

export default CreateJob;
